appComum.controller("LoginController", [
  "$scope",
  "$rootScope",
  "$http",
  "$uibModal",
  "$window",
  "$element",
  "emissorService",
  function ($scope, $rootScope, $http, $uibModal, $window, element, emissorService) {
    $scope.LOADING = false;

    $scope.doLogin = function () {
      $window.location.href = "/beneficiario/dashboard.html";
    };

    $scope.abrirModalAntiFraude = function (data) {
      const siglaEmissor = emissorService.getSigla();
      $uibModal.open({
        templateUrl: `/portal/app/UI-Comum/partials-emissor/${siglaEmissor}/modals/mfa/anti-fraude.html`,
        controller: "modalAntiFraudeController",
        backdrop: "static",
        size: "lg",
        keyboard: false,
        resolve: {
          data: function () {
            return data;
          },
        },
      });
    };

    $scope.abrirModalMigracaoSpe = function (data) {
      $uibModal.open({
        templateUrl: "/portal/app/UI-Comum/partials-emissor/VRPAT/modals/redirecionar-super-portal.html",
        controller: "modalMigracaoSpeController",
        backdrop: "static",
        size: "lg",
        keyboard: false,
        resolve: {
          data: function () {
            return data;
          },
        },
      });
    };

    $scope.openTermsModal = function (modelName) {
      const siglaEmissor = emissorService.sigla;

      var uibModalInstance = $uibModal.open({
        templateUrl: `/portal/app/UI-Comum/partials-emissor/${siglaEmissor}/modals/termos-de-uso.html`,
        controller: "TermosDeUsoController",
        size: "lg",
        windowClass: "termo-de-uso",
        resolve: {
          param: function () {
            return {
              referencia: "o",
              nomeEmissor: $rootScope.i18n.termos_de_uso.nome_emissor,
              nomePortal: $rootScope.i18n.termos_de_uso.nome_portal,
            };
          },
        },
      });

      uibModalInstance.result.then(function (response) {
        if (response) {
          $scope[modelName] = response;
        }
      });
    };

    $scope.carregarDadosUsuario = function () {
      if ($scope.cpf) {
        $scope.LOADING = true;
        $http({
          method: "POST",
          url: "/api-web/comum/legado/usercontrol/consultar-dados-por-pf",
          data: {
            siglaEmissor: emissorService.sigla.toLowerCase(),
            cpf: $scope.cpf,
          },
          headers: {
            "Content-Type": "application/json",
          },
        })
          .success(function (data) {
            $scope.LOADING = false;
            if (data) {
              if (constants.SETTINGS.DEBUG) {
                console.log("LoginController: resultado da requisição: ");
                console.dir(data);
              }

              if (data.code == 0) {
                if (!$scope.name) {
                  $scope.name = data.dados.nome;
                }

                if (!$scope.login) {
                  $scope.login = data.dados.email;
                }

                if (!$scope.cel) {
                  if (data.dados.celular) {
                    if (data.dados.celular.length > 9) {
                      $scope.cel = data.dados.celular;
                    }
                  }
                }

                if (!$scope.birth) {
                  $scope.birth = data.dados.dataNascimento;
                }
              }
            }
          })
          .error(function () {
            $scope.LOADING = false;
          });
      }
    };

    function validateFiledFromToken(inp, name) {
      if (name !== "") {
        angular.element(inp).removeClass("ng-pristine").removeClass("ng-untouched").addClass("ng-dirty ng-touched");
      }
    }

    // faz o auto complete dos compos de cadastro quando tiver o
    // parametro token
    $scope.autoCompleteFields = function (data) {
      // $scope.name = data.name;
      // $scope.cpf = data.cpf;

      // form-control ng-valid ng-valid-required ng-dirty ng-valid-parse ng-touched
      angular.forEach(element.find("input"), function (inp) {
        switch (inp.name) {
          case "name":
            $scope.name = data.name;
            validateFiledFromToken(inp, data.name);
            break;
          case "cpf":
            // inp.value = data.cpf;
            $scope.cpf = data.cpf;
            validateFiledFromToken(inp, data.cpf);
            break;
          case "celular":
            $scope.celular = data.celular;
            validateFiledFromToken(inp, data.celular);
          case "cel":
            // inp.value = data.celular;
            $scope.cel = data.celular;
            validateFiledFromToken(inp, data.celular);
            break;
          case "birth":
          case "birth.date":
            // inp.value = data.birth;
            $scope.birth = data.birth;
            validateFiledFromToken(inp, data.birth);
            break;
          case "email":
            $scope.email = data.email;
            validateFiledFromToken(inp, data.email);
            break;
          case "login":
            $scope.login = data.email;
            validateFiledFromToken(inp, data.email);
            break;
          case "emailConfirmation":
            $scope.emailConfirmation = data.emailConfirmation;
            validateFiledFromToken(inp, data.emailConfirmation);
            break;
          case "confirmLogin":
            $scope.confirmLogin = data.emailConfirmation;
            validateFiledFromToken(inp, data.emailConfirmation);
            break;
        }
      });
    };

    var pageName = $window.location.pathname;

    // verifica se esta na pagina do cadastre
    if (pageName.indexOf("login/cadastr") !== -1 || pageName.indexOf("ui-comum/registro.html") !== -1) {
      // BOxCgTyCNDMMAJNpsT7UNohbdQzJ8z5f
      var url = new URL($window.location.href);
      var token = url.searchParams.get("token");

      // se tiver token então faz a requisição e pega os dados do usuario
      if (token !== null) {
        $http({
          method: "GET",
          url: "/api-web/comum/assinante/" + token,
          headers: {
            "Content-Type": "application/json",
          },
        }).success(function (data, status) {
          $scope.autoCompleteFields(data);
        });
      }
    }

    $scope.redirectToTypeRegister = function (modelName) {
      var modalRedirectToregister = $uibModal.open({
        templateUrl: "/portal/app/UI-Comum/partials/modals/redirecionamento-tipo-cadastro.html",
        controller: "RedirecionamentoDeTipoDeRegistroController",
        windowClass: "redirect-to-register",
        size: "sm",
        resolve: {
          param: function () {
            return {
              referencia: "o",
              nomeEmissor: "GPA",
              nomePortal: "Multi Benefícios",
            };
          },
        },
      });

      modalRedirectToregister.result.then(function (response) {
        if (response) {
          $scope[modelName] = response;
        }
      });
    };

    $scope.togglePassword = (event) => {
      var password = angular.element(document.querySelector("#password"));
      password.focus();

      const typeInput = password[0].getAttribute("type") == "text" ? "password" : "text";
      password[0].setAttribute("type", typeInput);
    };

    $scope.init = () => {
      $rootScope.clearSessionStorage();
    };

    $scope.init();

    if (constants.SETTINGS.DEBUG) {
      $scope.exposeScope("LoginController", $scope);
    }

    $("#birthdate").on("change", function () {
      $scope.birth = $(this).val();
    });
  },
]);

appComum.controller("RedirecionamentoDeTipoDeRegistroController", [
  "$scope",
  "$uibModalInstance",
  "vrModalCustomize",
  "param",
  "$window",
  function ($scope, $uibModalInstance, vrModalCustomize, param, $window) {
    vrModalCustomize.toCenter($uibModalInstance);

    $scope.goToEc = function () {
      $window.location = "/portal/app/simule-compre/#/";
      $uibModalInstance.close(true);
    };

    $scope.goToCompany = function () {
      $window.location = "/portal/portal-vr/login/cadastro.html";
      $uibModalInstance.close(true);
    };

    $scope.close = function () {
      $uibModalInstance.close(true);
    };

    if (constants.SETTINGS.DEBUG) {
      $scope.exposeScope("RedirecionamentoDeTipoDeRegistroController", $scope);
    }
  },
]);

appComum.controller("modalAntiFraudeController", [
  "$rootScope",
  "$scope",
  "$uibModal",
  "$uibModalInstance",
  "$interval",
  "solicitarMfa",
  "solicitarCodigoMfa",
  "login",
  "password",
  "$cookies",
  "erroCodigoMfa",
  "codigoErroMfa",
  "emailVrid",
  function (
    $rootScope,
    $scope,
    $uibModal,
    $uibModalInstance,
    $interval,
    solicitarMfa,
    solicitarCodigoMfa,
    login,
    password,
    $cookies,
    erroCodigoMfa,
    codigoErroMfa,
    emailVrid
  ) {
    $scope.LOADING = false;

    $scope.passoAtual = 1;
    $scope.erroValidacaoAcesso = false;
    $scope.codigoInvalido = false;
    $scope.codigoExpirado = false;
    $scope.usuarioBloqueado = false;
    $scope.codigoDigitado = "";

    if ($cookies.mfaPassoAtual !== undefined && $cookies.mfaPassoAtual !== null) {
      $scope.passoAtual = Number($cookies.mfaPassoAtual);
    }

    $scope.codigoValidado = false;

    $scope.solicitarMfa = solicitarMfa;
    $scope.solicitarCodigoMfa = solicitarCodigoMfa;
    $scope.erroCodigoMfa = erroCodigoMfa;
    $scope.codigoErroMfa = codigoErroMfa;
    $scope.login = login;
    $scope.password = password;
    $scope.emailVrid = emailVrid;

    if (emailVrid) {
      $scope.emailVrid = formatarEmail(emailVrid);
    }

    if (login) {
      $scope.login = formatarEmail(login);
    }

    var intervalo;

    //Função para tratar os diversos tipos de erro
    $scope.trataMensagemErro = function () {
      if ($scope.erroCodigoMfa.includes("expirado")) {
        $scope.codigoExpirado = true;
      } else if ($scope.erroCodigoMfa.includes("inválido")) {
        $scope.codigoInvalido = true;
      } else if ($scope.erroCodigoMfa.includes("bloqueada")) {
        $scope.usuarioBloqueado = true;
      } else {
        $scope.erroValidacaoAcesso = true;
      }
    };
    //Fim da função para tratar os diversos tipos de erro

    if ($scope.erroCodigoMfa) {
      $scope.trataMensagemErro();
    }

    $scope.iniciarContador = function (valorInicial) {
      $interval.cancel(intervalo);
      $scope.contador = valorInicial;
      $scope.formatoContador = formatarContador($scope.contador);

      intervalo = $interval(function () {
        if ($scope.contador > -1) {
          $scope.contador--;
          $scope.formatoContador = formatarContador($scope.contador);
        }
      }, 1000);
    };

    function formatarContador(valor) {
      var minutos = Math.floor(valor / 60);
      var segundos = valor % 60;

      return minutos.toString().padStart(2, "0") + ":" + segundos.toString().padStart(2, "0");
    }

    function formatarEmail(email) {
      var nomeUsuario = email.substring(0, email.indexOf("@"));
      var dominio = email.substring(email.indexOf("@") + 1);

      var numCaracteresMostrar = 3;

      var numAsteriscos = 5;

      var asteriscos = "";
      for (var i = 0; i < numAsteriscos; i++) {
        asteriscos += "*";
      }

      return asteriscos + nomeUsuario.slice(-numCaracteresMostrar) + "@" + dominio;
    }

    $scope.enviarCodigoEmail = function () {
      $scope.LOADING = true;
      submitLoginMfa(login, password);
    };

    if ($scope.solicitarCodigoMfa) {
      $scope.LOADING = false;
      $scope.solicitarCodigoMfa = false;
    }

    if ($scope.usuarioBloqueado || $scope.erroValidacaoAcesso) {
      $scope.LOADING = false;
    }

    $scope.cancel = function () {
      $uibModalInstance.close(true);
      $cookies.mfaPassoAtual = 1;
      var modalElement = document.querySelector(".modal");
      modalElement.remove();
    };

    $scope.handleNext = function () {
      $scope.passoAtual += 1;
      $cookies.mfaPassoAtual = $scope.passoAtual;
    };

    $scope.handleBack = function () {
      $scope.passoAtual -= 1;
      $cookies.mfaPassoAtual = $scope.passoAtual;
    };

    // Inicio input de codigo de segurança
    $scope.code = ["", "", "", "", "", ""];

    $scope.onInput = function (index, event) {
      // Limitar a entrada a um caractere
      if ($scope.code[index].length > 1) {
        $scope.code[index] = $scope.code[index].substring(0, 1);
      }

      // Focar automaticamente no próximo campo quando preenchido
      if (index < 5 && $scope.code[index].length === 1) {
        document.getElementById("code-input-" + (index + 1)).focus();
      }

      // Verificar se todos os dígitos estão preenchidos
      if ($scope.code.every((char) => char)) {
        var codeString = $scope.code.join("");
        $scope.codigoDigitado = codeString;
        submitCodigoMfa(login, password, codeString);
        $scope.LOADING = true;
      }
    };

    $scope.onKeyDown = function (index, event) {
      // Lidar com o press da tecla Backspace
      if (event.key === "Backspace" && $scope.code[index].length === 0 && index > 0) {
        $scope.code[index - 1] = "";
        document.getElementById("code-input-" + (index - 1)).focus();
      }
    };

    $scope.onPaste = function (event) {
      event.preventDefault();

      var pastedText = (event.originalEvent || event).clipboardData.getData("text") || window.clipboardData.getData("Text");

      // Lidar com o texto colado mais longo
      if (pastedText.length >= 6) {
        pastedText = pastedText.substring(0, 6); // Extrair apenas os primeiros 6 caracteres
      }

      for (var i = 0; i < 6; i++) {
        $scope.code[i] = pastedText.charAt(i);
        document.getElementById("code-input-" + i).focus();
      }

      if ($scope.code.every((char) => char)) {
        var codeString = $scope.code.join("");
        $scope.codigoDigitado = codeString;
        submitCodigoMfa(login, password, codeString);
        $scope.LOADING = true;
      }
    };
    // Fim input de codigo de segurança
  },
]);

appComum.controller("modalMigracaoSpeController", [
  "$rootScope",
  "$scope",
  "$uibModal",
  "$uibModalInstance",
  "$interval",
  "$cookies",
  "$window",
  "usuarioMigradoSPE",
  "login",
  function ($rootScope, $scope, $uibModal, $uibModalInstance, $interval, $cookies, $window, usuarioMigradoSPE, login) {
    const LINK_SPE_DEFAULT = "https://superportal-empregador.vr.com.br/recuperar_acesso";
    const LINK_SPE_DEV = "https://superportal-empregador-dev.vr.com.br/recuperar_acesso";
    const LINK_SPE_QA = "https://superportal-empregador-qa.vr.com.br/recuperar_acesso";

    const LINK_SPE_DEFAULT_LOGIN = "https://superportal-empregador.vr.com.br/entrar";
    const LINK_SPE_DEV_LOGIN = "https://superportal-empregador-dev.vr.com.br/entrar";
    const LINK_SPE_QA_LOGIN = "https://superportal-empregador-qa.vr.com.br/entrar";

    $scope.LOADING = false;
    $scope.usuarioMigradoSPE = usuarioMigradoSPE;
    $scope.login = login;
    $scope.numeroAtual = null;
    $scope.linkSPE = "";
    $scope.linkSPELogin = "";
    $scope.ambiente = "";

    function checarAmbiente() {
      const hostname = $window.location.hostname;
      if (hostname.includes("dsp.vr.com.br")) {
        $scope.linkSPE = LINK_SPE_DEV;
        $scope.linkSPELogin = LINK_SPE_DEV_LOGIN;
      } else if (hostname.includes("portalhmp.vr.com.br")) {
        $scope.linkSPE = LINK_SPE_QA;
        $scope.linkSPELogin = LINK_SPE_QA_LOGIN;
      } else {
        $scope.linkSPE = LINK_SPE_DEFAULT;
        $scope.linkSPELogin = LINK_SPE_DEFAULT_LOGIN;
      }
    }

    function redirectToSPE() {
      $window.location.href = $scope.linkSPE;
    }

    function redirectToSPELogin() {
      $window.location.href = $scope.linkSPELogin;
    }

    $scope.redirecionarSPE = redirectToSPE;
    $scope.redirecionarSPELogin = redirectToSPELogin;

    $scope.cancel = function () {
      $uibModalInstance.close(true);
      var modalElement = document.querySelector(".modal");
      if (modalElement) {
        modalElement.remove();
      }
    };

    checarAmbiente();
  },
]);

appComum.directive("vrMfa", [
  "$uibModal",
  "emissorService",
  function ($uibModal, emissorService) {
    return {
      scope: {
        solicitarMfa: "@",
        solicitarCodigoMfa: "@",
        login: "@",
        password: "@",
        erroCodigoMfa: "@",
        codigoErroMfa: "@",
        emailVrid: "@",
      },
      controller: "LoginController",
      restrict: "AE",
      replace: true,
      link: function (scope, attrs) {
        scope.abrirModalAntiFraude = function (data) {
          const siglaEmissor = emissorService.getSigla();
          $uibModal.open({
            templateUrl: `/portal/app/UI-Comum/partials-emissor/${siglaEmissor}/modals/mfa/anti-fraude.html`,
            controller: "modalAntiFraudeController",
            backdrop: "static",
            size: "lg",
            keyboard: false,
            resolve: {
              solicitarMfa: function () {
                return scope.solicitarMfa;
              },
              solicitarCodigoMfa: function () {
                return scope.solicitarCodigoMfa;
              },
              login: function () {
                return scope.login;
              },
              password: function () {
                return scope.password;
              },
              erroCodigoMfa: function () {
                return scope.erroCodigoMfa;
              },
              codigoErroMfa: function () {
                return scope.codigoErroMfa;
              },
              emailVrid: function () {
                return scope.emailVrid;
              },
            },
          });
        };
        scope.abrirModalAntiFraude();
      },
    };
  },
]);

appComum.directive("vrMigracaoSpe", [
  "$uibModal",
  function ($uibModal) {
    return {
      scope: {
        usuarioMigradoSPE: "@",
        login: "@",
      },
      controller: "LoginController",
      restrict: "AE",
      replace: true,
      link: function (scope, attrs) {
        scope.abrirModalMigracaoSpe = function (data) {
          $uibModal.open({
            templateUrl: "/portal/app/UI-Comum/partials-emissor/VRPAT/modals/redirecionar-super-portal.html",
            controller: "modalMigracaoSpeController",
            backdrop: "static",
            size: "lg",
            keyboard: false,
            resolve: {
              usuarioMigradoSPE: function () {
                return scope.usuarioMigradoSPE;
              },
              login: function () {
                return scope.login;
              },
            },
          });
        };
        scope.abrirModalMigracaoSpe();
      },
    };
  },
]);
